<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import MobileModal from '@/components/MobileModal.vue';

defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits([
  'close',
  'checkout',
  'continueSearching',
]);

const { t } = useI18n();
</script>

<template>
  <MobileModal
    :is-open="isOpen"
    :title="t('cart.addedToCart')"
    @close="emit('close')"
  >
    <template #title>
      <span class="title-content">
        <svg class="check-icon" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12.864 24.8643C19.4916 24.8643 24.864 19.4919 24.864 12.8643C24.864 6.23666 19.4916 0.864258 12.864 0.864258C6.23641 0.864258 0.864014 6.23666 0.864014 12.8643C0.864014 19.4919 6.23641 24.8643 12.864 24.8643Z" fill="#2C93F4" />
          <path d="M9.26401 12.8643L11.664 15.2643L16.464 10.4643" fill="#2C93F4" />
          <path d="M9.26401 12.8643L11.664 15.2643L16.464 10.4643M12.864 24.8643C19.4916 24.8643 24.864 19.4919 24.864 12.8643C24.864 6.23666 19.4916 0.864258 12.864 0.864258C6.23641 0.864258 0.864014 6.23666 0.864014 12.8643C0.864014 19.4919 6.23641 24.8643 12.864 24.8643Z" stroke="white" stroke-width="1.728" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ t('cart.addedToCart') }}</span>
      </span>
    </template>

    <template #body>
      <div class="action-buttons">
        <button class="checkout-button" @click="emit('checkout')">
          {{ t('cart.checkout') }}
        </button>
        <button class="continue-button" @click="emit('continueSearching')">
          {{ t('cart.continueSearching') }}
        </button>
      </div>
    </template>
  </MobileModal>
</template>

<style scoped lang="css">
.title-content {
  display: flex;
  align-items: center;
  gap: var(--yb-spacing-sm);
}

.check-icon {
  flex-shrink: 0;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: var(--yb-spacing-sm);
}

.checkout-button {
  background-color: var(--yb-color-primary);
  color: var(--yb-button-text-color);
  border: none;
  border-radius: 8px;
  padding: var(--yb-spacing-sm) var(--yb-spacing-base);
  font-size: var(--yb-text-base);
  font-weight: var(--yb-text-bold);
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.checkout-button:hover {
  opacity: 0.9;
}

.continue-button {
  background-color: var(--yb-color-white);
  color: var(--yb-color-black);
  border: 2px solid var(--yb-color-black);
  border-radius: 8px;
  padding: var(--yb-spacing-sm) var(--yb-spacing-base);
  font-size: var(--yb-text-base);
  font-weight: var(--yb-text-bold);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.continue-button:hover {
  background-color: #f5f5f5;
}

@media (prefers-reduced-motion: reduce) {
  .checkout-button,
  .continue-button {
    transition: none;
  }
}
</style>
